import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API_URLS } from "./apis/urls";
import Api from "./utils/apiCall";
import { tokenService } from "../../utils/tokenService";

interface AdminAuthState {
  data: any;
  loading: "idle" | "pending" | "fulfilled" | "rejected";
  error: string | null;
  user: any;
  action: "employee-login" | "verify-login-otp" | "logout" | "forgot-password" |
  "verify-otp" | "reset-password" | "resend-otp" | "change-password" | null;
}

interface AdminAuthData {
  email: string;
  password: string;
  role: string;
}

const adminAuthInitialState: AdminAuthState = {
  data: null,
  loading: "idle",
  error: null,
  user: null,
  action: null
};


export const getLogin: any = createAsyncThunk(
  "admin-auth/login",
  async (credentials: AdminAuthData, thunkAPI) => {
    try {
      const response = await Api.post(API_URLS.ADMIN_AUTH.GET_LOGIN, credentials);
      //console.log('response--',response)
      //localStorage.setItem("authorization", response?.data?.data?.access_token);
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);

export const verifyLoginOtp: any = createAsyncThunk(
  "admin-auth/verify-login-otp",
  async (credentials: AdminAuthData, thunkAPI) => {
    try {
      const response = await Api.post(API_URLS.ADMIN_AUTH.VERIFY_LOGIN_OTP, credentials);
      //console.log('response--',response)
      if (response?.data?.data?.access_token) {
        tokenService.setToken(response?.data?.data?.access_token);
      }
      localStorage.setItem("user", JSON.stringify(response?.data?.data?.user));
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);


export const forgotPassword: any = createAsyncThunk(
  "admin-auth/forgot-password",
  async (credentials: AdminAuthData, thunkAPI) => {
    try {
      const response = await Api.post(API_URLS.ADMIN_AUTH.FORGOT_PASSWORD, credentials);
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);

export const verifyOtp: any = createAsyncThunk(
  "admin-auth/verify-otp",
  async (credentials: AdminAuthData, thunkAPI) => {
    try {
      const response = await Api.post(API_URLS.ADMIN_AUTH.VERIFY_OTP, credentials);
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);

export const resetPassword: any = createAsyncThunk(
  "admin-auth/reset-password",
  async (credentials: AdminAuthData, thunkAPI) => {
    try {
      const response = await Api.post(API_URLS.ADMIN_AUTH.RESET_PASSWORD, credentials);
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);

export const changePassword: any = createAsyncThunk(
  "admin-auth/change-password",
  async (credentials: AdminAuthData, thunkAPI) => {
    try {
      const response = await Api.post(API_URLS.ADMIN_AUTH.CHANGE_PASSWORD, credentials);
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);

export const resendOtp: any = createAsyncThunk(
  "admin-auth/resend-otp",
  async (credentials: AdminAuthData, thunkAPI) => {
    try {
      const response = await Api.post(API_URLS.ADMIN_AUTH.RESEND_OTP, credentials);
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);



const adminAuthSlice = createSlice({
  name: "auth",
  initialState: adminAuthInitialState,
  reducers: {
    logout: (state: any) => {
      state.data = null;
      state.loading = "idle";
      state.action = "logout";
    },
    resetAuthError: (state: any) => {
      state.loading = "idle";
      state.error = null;
      state.action = null;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(getLogin.pending, (state) => {
      state.loading = "pending";
      state.action = "employee-login";
      state.error = null;
    });
    builder.addCase(getLogin.fulfilled, (state, action) => {
      state.loading = "fulfilled";
      state.user = action.payload;
      state.data = null;
      state.action = "employee-login";
      state.error = null;
    });
    builder.addCase(getLogin.rejected, (state, action) => {
      state.loading = "rejected";
      state.error = action.payload as string;
      state.action = "employee-login";
    });





    builder.addCase(verifyLoginOtp.pending, (state) => {
      state.loading = "pending";
      state.action = "verify-login-otp";
      state.error = null;
    });
    builder.addCase(verifyLoginOtp.fulfilled, (state, action) => {
      state.loading = "fulfilled";
      state.user = action.payload;
      state.data = null;
      state.action = "verify-login-otp";
      state.error = null;
    });
    builder.addCase(verifyLoginOtp.rejected, (state, action) => {
      state.loading = "rejected";
      state.error = action.payload as string;
      state.action = "verify-login-otp";
    });


    builder.addCase(forgotPassword.pending, (state) => {
      state.loading = "pending";
      state.action = "forgot-password";
      state.error = null;
    });
    builder.addCase(forgotPassword.fulfilled, (state, action) => {
      state.loading = "fulfilled";
      state.user = action.payload;
      state.data = null;
      state.action = "forgot-password";
      state.error = null;
    });
    builder.addCase(forgotPassword.rejected, (state, action) => {
      state.loading = "rejected";
      state.error = action.payload as string;
      state.action = "forgot-password";
    });


    builder.addCase(verifyOtp.pending, (state) => {
      state.loading = "pending";
      state.action = "verify-otp";
      state.error = null;
    });
    builder.addCase(verifyOtp.fulfilled, (state, action) => {
      state.loading = "fulfilled";
      state.user = action.payload;
      state.data = null;
      state.action = "verify-otp";
      state.error = null;
    });
    builder.addCase(verifyOtp.rejected, (state, action) => {
      state.loading = "rejected";
      state.error = action.payload as string;
      state.action = "verify-otp";
    });

    //==
    builder.addCase(resetPassword.pending, (state) => {
      state.loading = "pending";
      state.action = "reset-password";
      state.error = null;
    });
    builder.addCase(resetPassword.fulfilled, (state, action) => {
      state.loading = "fulfilled";
      state.user = action.payload;
      state.data = null;
      state.action = "reset-password";
      state.error = null;
    });
    builder.addCase(resetPassword.rejected, (state, action) => {
      state.loading = "rejected";
      state.error = action.payload as string;
      state.action = "reset-password";
    });



    builder.addCase(changePassword.pending, (state) => {
      state.loading = "pending";
      state.action = "change-password";
      state.error = null;
    });
    builder.addCase(changePassword.fulfilled, (state, action) => {
      state.loading = "fulfilled";
      state.user = action.payload;
      state.data = null;
      state.action = "change-password";
      state.error = null;
    });
    builder.addCase(changePassword.rejected, (state, action) => {
      state.loading = "rejected";
      state.error = action.payload as string;
      state.action = "change-password";
    });




    builder.addCase(resendOtp.pending, (state) => {
      state.loading = "pending";
      state.action = "resend-otp";
      state.error = null;
    });
    builder.addCase(resendOtp.fulfilled, (state, action) => {
      state.loading = "fulfilled";
      state.user = action.payload;
      state.data = null;
      state.action = "resend-otp";
      state.error = null;
    });
    builder.addCase(resendOtp.rejected, (state, action) => {
      state.loading = "rejected";
      state.error = action.payload as string;
      state.action = "resend-otp";
    });





  },
});

export const { logout, resetAuthError } = adminAuthSlice.actions;

export default adminAuthSlice.reducer;
